const transformUrl = (url: string): string => {
  const isDocker = import.meta.env.VITE_IS_DOCKER === 'true';
  
  if (isDocker && url.includes('backend')) {
    return url.replace('backend', 'host.docker.internal');
  }
  
  if (url.includes('backend')) {
    return url.replace('backend:5555', 'localhost:5555');
  }
  
  return url;
};

export const API_BASE_URL = 'https://api.vorwerk.repair';

export const APIConfig = {
  BASE_URL: API_BASE_URL
};
